import { isEmpty } from 'lodash'
import { IMyAccountContext } from '../../hooks/useMyAccountContext'
import { BaseClientConfig, authEndPath } from '@news-mono/web-common'
import { removeRegistrationCookies } from '../../../user-registration'

interface DeleteAccountMutateProps {
    onDeleteAccount: () => any
    sendForgotPasswordEmail: () => any
}
interface DeleteAccountPasswordProps {
    passwordText?: string
}
export interface DeleteAccountClickProps {
    // Context values below:
    myAccountContext: IMyAccountContext
    configContext: BaseClientConfig
    mutateProps: DeleteAccountMutateProps
    // State values below:
    passwordState: DeleteAccountPasswordProps
}

export const onDeleteAccountClick = async ({
    myAccountContext,
    configContext,
    mutateProps,
    passwordState,
}: DeleteAccountClickProps) => {
    const { setMessageBanner } = myAccountContext
    const { onDeleteAccount } = mutateProps
    const { passwordText } = passwordState

    if (isEmpty(passwordText)) {
        return
    }

    // Set the submitting state
    const res = await onDeleteAccount()

    if (res.result) {
        // remove any cookies that are added as part of the registration process
        removeRegistrationCookies(configContext)

        // log user out and then redirect to the successful account deleted page
        const endPathURL = new URL(`${configContext.publicUrl}${authEndPath}`)
        endPathURL.searchParams.append('deleteAccount', 'true')

        window.location.assign(endPathURL)
    } else {
        setMessageBanner({
            type: 'error',
            text: res.message,
        })
    }
}

export const onForgotPasswordClick = async ({
    myAccountContext,
    mutateProps,
}: DeleteAccountClickProps) => {
    const { setMessageBanner, setToast } = myAccountContext
    const { sendForgotPasswordEmail } = mutateProps
    setMessageBanner(undefined)
    const res = await sendForgotPasswordEmail()
    if (res.result) {
        setToast({
            text: res.message,
            type: 'success',
            show: true,
        })
    } else {
        setMessageBanner({
            type: 'error',
            text: res.message,
        })
    }
}
